import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vp-features"
}

import { computed } from 'vue'
import { usePageFrontmatter } from 'vuepress/client'
import type { DefaultThemeHomePageFrontmatter } from '../../shared/index.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPHomeFeatures',
  setup(__props) {

const frontmatter = usePageFrontmatter<DefaultThemeHomePageFrontmatter>()

const features = computed(() => frontmatter.value.features ?? [])

return (_ctx: any,_cache: any) => {
  return (features.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (feature) => {
          return (_openBlock(), _createElementBlock("div", {
            key: feature.title,
            class: "vp-feature"
          }, [
            _createElementVNode("h2", null, _toDisplayString(feature.title), 1),
            _createElementVNode("p", null, _toDisplayString(feature.details), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})